import { useContext } from 'react';

import { createGaEvent, dispatchGaEvent } from 'app/packages/analytics';

import { CHECK_ICON_TIME_DURATION, SHAKE_ANIM_DURATION } from '../constants';
import { AuthContext } from '../context';

const useAuthResult = () => {
  const { setAuthData } = useContext(AuthContext);

  return {
    successHandler: () => {
      setAuthData((prevState) => ({ ...prevState, loginDataChecked: true }));
      dispatchGaEvent(createGaEvent({ event: 'logInConfirm' }));
      setTimeout(() => {
        sessionStorage.removeItem('phone');
      }, CHECK_ICON_TIME_DURATION);
    },
    errorHandler: () => {
      setAuthData((prevState) => ({
        ...prevState,
        errorMessage: true,
        showFieldError: true,
        shake: true,
      }));

      setTimeout(() => {
        setAuthData((prevState) => ({ ...prevState, shake: false }));
      }, SHAKE_ANIM_DURATION);
    },
  };
};

export default useAuthResult;
